import { FormattedMessage } from 'react-intl';

import { SincePeriod } from '@xing-com/crate-common-graphql-types';

export const SINCE_PERIOD_OPTIONS: Record<SincePeriod, React.ReactElement> = {
  [SincePeriod.Last_24Hours]: (
    <FormattedMessage id="JOBS_SEARCH_FILTER_TIME_FRAME_LAST_24_HOURS" />
  ),
  [SincePeriod.LastWeek]: (
    <FormattedMessage id="JOBS_SEARCH_FILTER_TIME_FRAME_LAST_WEEK" />
  ),
  [SincePeriod.LastMonth]: (
    <FormattedMessage id="JOBS_SEARCH_FILTER_TIME_FRAME_LAST_MONTH" />
  ),
};
